import { useCallback, useContext } from 'react';
import { NotificationContext } from '../contexts/notification.context';
import { copyText } from '../helpers/clipboard.helper';
import { logError } from '../helpers/logger.helper';

/**
 * Returns a function that copies `text` to the clipboard and shows a
 * success toast (defaulting to "Copied to clipboard"), or an error toast if
 * nothing copies.
 */
export const useCopyToClipboard = () => {
  const { renderNotification } = useContext(NotificationContext);

  return useCallback(
    async (text: string, successMessage = 'Copied to clipboard') => {
      try {
        await copyText(text);
        renderNotification('success', successMessage);
      } catch (error) {
        // The user gets a generic message; the error's cause keeps the
        // clipboard API's refusal for debugging.
        logError(error);
        renderNotification('error', 'Failed to copy to clipboard');
      }
    },
    [renderNotification]
  );
};
